module.exports = __webpack_public_path__ + "img/taskman.5746d03c.png";